import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExecutorDashboardComponent } from './executor-dashboard.component';
import { ExecutorDashboardRoutingModule } from './executor-dashboard-routing.module';
import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ExecutionComponent } from '../components/execution/execution.component';
import { ProgressTrackerComponent } from '../components/progress-tracker/progress-tracker.component';
import { RequestUserAccessComponent } from '../components/request-user-access/request-user-access.component';
import { AssessmentComponent } from '../components/assessment/assessment.component';
import { UserProfileComponent } from '../components/user-profile/user-profile.component';
import { HistoricalAssessmentComponent } from '../components/historical-assessment/historical-assessment.component';
import { ResubmitClarifyComponent } from '../components/resubmit-clarify/resubmit-clarify.component';
import { RiskRatingComponent } from '../components/risk-rating/risk-rating.component';
import { ReportIssueComponent } from '../components/report-issue/report-issue.component';
import { AlertModule, AlertConfig } from 'ngx-bootstrap/alert';
import { CasesComponent } from '../components/cases/cases.component';
import { ReportingComponent } from '../components/reporting/reporting.component';
import { MonitoringComponent } from '../components/monitoring/monitoring.component';
import { SafeUrlPipe } from '../core/pipes/safe-url.pipe';
import { ReviewComponent } from '../components/review/review.component';
import { ResubmitCheckerComponent } from '../components/resubmit-checker/resubmit-checker.component';
import { ActionItemsComponent } from '../components/action-items/action-items.component';
import { ProgressDetailChartComponent } from '../components/progress-detail-chart/progress-detail-chart.component';
import { ChartDoughnutComponent } from '../components/chart-doughnut/chart-doughnut.component';
import { NgChartsModule } from 'ng2-charts';
import { ResourcesComponent } from '../components/resources/resources.component';
import { HistoricalActionItemsComponent } from '../components/historical-action-items/historical-action-items.component';
import { PendingActionItemsComponent } from '../components/pending-action-items/pending-action-items.component';
import { RejectedActionItemsComponent } from '../components/rejected-action-items/rejected-action-items.component';
import { ActionItemDetailComponent } from '../components/action-item-detail/action-item-detail.component';

import { EnforcementComponent } from '../components/enforcement/enforcement.component';
import { FinesComponent } from '../components/fines/fines.component';
import { AppealComponent } from '../components/appeal/appeal.component';
import { EnforcementSelectComponent } from '../components/enforcement-select/enforcement-select.component';
import { EnforcementHistoricalComponent } from '../components/enforcement-historical/enforcement-historical.component';
import { EnforcementDetailComponent } from '../components/enforcement-detail/enforcement-detail.component';
import { FinesSelectComponent } from '../components/fines-select/fines-select.component';
import { FinesHistoricalComponent } from '../components/fines-historical/fines-historical.component';
import { FinesDetailComponent } from '../components/fines-detail/fines-detail.component';
import { AppealSelectComponent } from '../components/appeal-select/appeal-select.component';
import { AppealHistoricalComponent } from '../components/appeal-historical/appeal-historical.component';
import { AppealDetailComponent } from '../components/appeal-detail/appeal-detail.component';

@NgModule({
  declarations: [
    ExecutorDashboardComponent, ExecutionComponent, ProgressTrackerComponent, ProgressDetailChartComponent,
    RequestUserAccessComponent, AssessmentComponent, ChartDoughnutComponent,
    UserProfileComponent, HistoricalAssessmentComponent,
    ResubmitClarifyComponent, RiskRatingComponent, ResourcesComponent,
    ReportIssueComponent, CasesComponent, MonitoringComponent, ReviewComponent,
    ResubmitCheckerComponent, ReportingComponent, ActionItemsComponent, SafeUrlPipe,
    HistoricalActionItemsComponent, PendingActionItemsComponent,
    RejectedActionItemsComponent, ActionItemDetailComponent,EnforcementComponent,EnforcementSelectComponent,EnforcementHistoricalComponent,EnforcementDetailComponent,FinesComponent,FinesDetailComponent,FinesHistoricalComponent,AppealComponent,AppealDetailComponent,FinesSelectComponent,AppealSelectComponent,AppealHistoricalComponent
  ],
  imports: [
    CommonModule, ExecutorDashboardRoutingModule, SharedModule, FormsModule, ReactiveFormsModule, AlertModule, NgChartsModule
  ],
  exports: [ExecutorDashboardComponent],
  providers: [AlertConfig],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
})
export class ExecutorDashboardModule { }
